import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ContentViewer from '@/components/ContentViewer.vue'
import Login from './views/Login.vue'
import loginAPI from '@/api/LoginAPI.js'
import store from './store.js'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/:slug?/login',
      name: 'login',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/:slug?/change-password/:userID',
      name: 'changePassword',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "changePassword" */ './views/ChangePassword.vue')
    },
    {
      path: '/:slug?/change-password-needed/:userID',
      name: 'changePasswordNeeded',
      component: () => import(/* webpackChunkName: "changePasswordNeeded" */ './views/ChangePasswordNeeded.vue')
    },
    {
      path: '/:slug?/change-username-needed/:userID',
      name: 'changeUsernameNeeded',
      component: () => import(/* webpackChunkName: "changePasswordNeeded" */ './views/ChangeUsernameNeeded.vue')
    },
    {
      path: '/:slug?/reset-password',
      name: 'resetPassword',
      component: () => import(/* webpackChunkName: "resetPassword" */ './views/ResetPassword.vue')
    },
    {
      path: '/:slug?/reset-username',
      name: 'resetUsername',
      component: () => import(/* webpackChunkName: "resetPassword" */ './views/ResetUsername.vue')
    },
    {
      path: '/:slug?/logout',
      name: 'logout',
      beforeEnter(to, from, next){
        loginAPI.logout();
        next('/login');
      }
    },
    {
      path: '/:slug?',
      name: 'home',
      beforeEnter: requireAuth,
      component: Home
    },
    {
      path: '/content-viewer/:linkID?/:documentID?',
      name: 'contentViewer',
      component: ContentViewer
    },
    {
      path: '/content-viewer/:documentID?',
      name: 'mobileContentViewer',
      component: ContentViewer
    },
    {
      path: '/:slug?/account-information/:userID',
      name: 'accountInformation',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "accountInformation" */ './views/AccountInformation.vue')
    },
    {
      path: '/:slug?/accounts-management/admin',
      name: 'adminAccountManagement',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "accountInformation" */ './views/AdminAccountsManagement.vue')
    },
    {
      path: '/:slug?/accounts-management/user',
      name: 'userAccountManagement',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "accountInformation" */ './views/UserAccountsManagement.vue')
    },
    {
      path: '/:slug?/accounts-management/user/:userID',
      name: 'userAccountManagementForUser',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "accountInformation" */ './views/UserAccountsManagement.vue')
    },
    {
      path: '/:slug?/accounts-management/admin-invitation',
      name: 'adminAccountInvitation',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "accountInformation" */ './views/AdminAccountInvitation.vue')
    }
    

  ]
})
router.beforeEach((to, from, next) => {
  if (store.state.slug != null && store.state.slug != "" && to.params.slug == undefined && ( to.name != "contentViewer" ||  from.name == "home" || from.name == "resetPassword")) {

    next({
      name: to.name, 
      params: { ...to.params, slug: store.state.slug }
    })
  }
  else {
      next()
  }
})

async function requireAuth(to, from, next) {
  if (!loginAPI.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    // const findResults = loginAPI.loadLogo(to.path.substring(1));
  
    // store.commit('setLogo', findResults)    
  } 
  else if(!loginAPI.passwordUpdated()){
    var userID = store.state.userInfo.userID
    next({
      path: '/changePasswordNeeded/' + userID,
      query: { redirect: to.fullPath }
    })
  }
  else {
      next()
  }
}

export default router
